export enum Currency {
  Usa = 'USD',
  Mexico = 'MXN',
}
